import { t } from "@lingui/macro";

import { StatusWarningIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import { HStack, Text } from "@whoosh/design-system/src/components/primitive";

export const AvailabilityListError = () => {
  return (
    <HStack
      backgroundColor="surface-primary"
      borderColor="outline-status-error"
      borderWidth={1}
      mx={6}
      height={60}
      gap={3}
      borderRadius="2"
      px={6}
      alignItems="center"
    >
      <StatusWarningIcon color="icon-status-error" />
      <Text
        variant="mainSmallSemiBold"
        color="text-error"
      >{t`Error Retrieving Availability`}</Text>
    </HStack>
  );
};
